import {
  COMPLETE_REQUEST,
  COMPLETE_ADD_MANY_INCENTIVES,
  PICK_INCENTIVE_COST,
  FETCH_INCENTIVE_COSTS_START,
  ADD_PROVIDER_TO_INCENTIVE_SUCCESS,
  CLEAR_INCENTIVE_COST,
  REMOVE_PROVIDER_FROM_INCENTIVE_SUCCESS,
  FLASH_MESSAGE
} from '../actions';

const initialState = {
  data:          [],
  page:          0,
  total_entries: 0,
  errors:        undefined,
  loading:       false
};

const providerIncentiveCostReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPLETE_REQUEST: {
      const { items, page, total_entries, errors } = action.response.data;
      const newState = { page, total_entries, errors, loading: false };
      if (!items) {
        newState.data = [];
      } else {
        newState.data = items;
      }
      return {
        ...state,
        ...newState
      };
    }
    case PICK_INCENTIVE_COST: {
      const { incentiveCost } = action;
      return {
        ...state,
        selected:   incentiveCost,
        selectedId: incentiveCost.provider_incentive_cost_id
      };
    }
    case ADD_PROVIDER_TO_INCENTIVE_SUCCESS: {
      let idx = state.data.findIndex( d => d.provider_incentive_cost_id == action.incentiveCostId );
      let found = state.data[idx];
      found.providers_count++;
      let newData = [].concat(state.data);
      newData[idx] = found;
      return {
        ...state,
        data: newData,
      };
    }
    case REMOVE_PROVIDER_FROM_INCENTIVE_SUCCESS:
      let idx = state.data.findIndex( d => d.provider_incentive_cost_id == action.incentiveCostId );
      let found = state.data[idx];
      found.providers_count--;
      let newData = [].concat(state.data);
      newData[idx] = found;
      return {
        ...state,
        data: newData,
      };
    case CLEAR_INCENTIVE_COST:
      return { ...state, selected: undefined };
    case COMPLETE_ADD_MANY_INCENTIVES: {
      const incentiveCosts = action.response.data.provider_incentive_costs;
      if (incentiveCosts) {
        return {
          ...state,
          data:          incentiveCosts,
          page:          1,
          total_entries: incentiveCosts.length,
          errors:        undefined,
          loading:       false
        };
      } else {
        return state;
      }
    }
    case FETCH_INCENTIVE_COSTS_START:
      return {
        ...state,
        loading: true
      };
    case FLASH_MESSAGE:
      return {
        ...state,
        flashMessage: action.message
      };
    default:
      return state;
  }
};

export default providerIncentiveCostReducer;
